import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useServiceRequestLightTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
